module.exports = __webpack_public_path__ + "img/storage.96c5960d.jpg";